export const SUBSCRIBE_NEWS_LETTER_BEGIN = "SUBSCRIBE_NEWS_LETTER_BEGIN";
export const SUBSCRIBE_NEWS_LETTER_SUCCESS = "SUBSCRIBE_NEWS_LETTER_SUCCESS";
export const SUBSCRIBE_NEWS_LETTER_FAILURE = "SUBSCRIBE_NEWS_LETTER_FAILURE";
export const RESET_SUBSCRIBE_NEWS_LETTER = "RESET_SUBSCRIBE_NEWS_LETTER";

export const SUBMIT_CONTACT_FORM_BEGIN = "SUBMIT_CONTACT_FORM_BEGIN";
export const SUBMIT_CONTACT_FORM_SUCCESS = "SUBMIT_CONTACT_FORM_SUCCESS";
export const SUBMIT_CONTACT_FORM_FAILURE = "SUBMIT_CONTACT_FORM_FAILURE";
export const RESET_SUBMIT_CONTACT_FORM = "RESET_SUBMIT_CONTACT_FORM";
